import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.Branch_List = function (state, payload) {
  state.branch = payload
}

const state = {
  rows: [],
  row: null,
  condition: {},
  branch: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        branch: {api: 'M0101BranchService.findBranchForListBox'}
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('Branch_List', data.branch.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0602Student cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0602Student search')
    return client.postData({ data: { search: { api: 'M0602StudentService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0602Student add')
    commit('EDIT',
      {
        id: null,
        user: [{username: '', user_password: ''}],
        birthday: '',
        student_first_name: '',
        student_last_name: ''
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0602Student edit')
    return client.postData({ data: { find: { api: 'M0602StudentService.getDataDetails', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0602Student delete')
    return client.postData({ data: { delete: { api: 'M0602StudentService.deleteDataDetails', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0602Student save')
    return client.postData({ data: { save: { api: 'M0602StudentService.saveDataDetails', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
        alert('data saved!')
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0602Student download')
    return client.download({ data: { download: { api: 'M0602StudentService.downloadData', input: condition } } })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0602Student/M0602StudentStore.js